var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JoLoadMore',{key:"find-pop",ref:"loadmore",on:{"onRefresh":_vm.onRefresh,"onLoadMore":_vm.onLoadMore}},_vm._l((_vm.users),function(user){return _c('UserItem',{key:user.id,attrs:{"user":user}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }